import type PaginatedResponse from '@/types/PaginatedResponse'
import { http } from '../plugins/http'
import type { AxiosResponse } from 'axios'

import type Admin from '@/types/Admin'
import type DataResponse from '@/types/DataResponse'
import type MessageResponse from '@/types/MessageResponse'
import Ability from '@/types/Ability'
import Role from '@/types/Role'

interface ImpersonateAdminResponse {
  id: string
  name: string
  token: {
    accessToken: string
  }
}
export interface AdminUpdateRequest extends Admin {
  producer_ids: string[]
  roles: Role[]
  abilities: Ability[]
}

export default class AdminService {
  async fetch(): Promise<Admin> {
    const { data } = await http.get<AxiosResponse<Admin>>('/api/v1/office/admin/me')

    return data.data
  }

  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Admin>>> {
    return await http.get<PaginatedResponse<Admin>>(`/api/v1/office/admin/users?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<DataResponse<Admin>>(`/api/v1/office/admin/users/${id}`)
  }

  async update(id: string, body: AdminUpdateRequest) {
    return await http.put<DataResponse<Admin>>(`/api/v1/office/admin/users/${id}`, body)
  }

  async destroy(id: string) {
    return await http.delete<MessageResponse>(`/api/v1/office/admin/users/${id}`)
  }

  async store(body: AdminUpdateRequest) {
    return await http.post<DataResponse<Admin>>(`/api/v1/office/admin/users`, body)
  }

  async abilities(): Promise<Ability[]> {
    const { data } = await http.get<DataResponse<Ability[]>>(`/api/v1/office/admin/me/abilities`)

    return data.data
  }

  async getUserToken(admin_id: number, user_id: string): Promise<AxiosResponse<DataResponse<ImpersonateAdminResponse>>> {
    return await http.get<DataResponse<ImpersonateAdminResponse>>(`/api/admin/login/${admin_id}/${user_id}`)
  }
}
